import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { Route, Redirect } from 'react-router-dom'

import useAuth from 'hooks/use-auth'
import { trackPage } from 'track'

export default function TrackedGremlinRoute(props) {
  const {
    computedMatch,
    loggedIn,
    shouldRenderRoute,
    name,
    fallbackRedirectTo,
    path
  } = props
  const { currentTeamId } = useAuth()

  const computedMatchPath = computedMatch?.path
  useEffect(() => {
    // DO NOT send PAGE events to segment for public-facing pages
    // this creates an anonymous MTU and these add up and cost us significantly in our Segment bill
    // if users login then their anonymous events are tied to their id and tracked
    // but the login page is public and anyone (or any bot) can hit it and cost us money!
    if (loggedIn) {
      trackPage(name || computedMatchPath, {
        loggedIn,
        teamId: currentTeamId
      })
    }
  }, [
    currentTeamId, // We want to fire if teamId changes
    name,
    computedMatchPath,
    loggedIn
  ])

  return shouldRenderRoute ? (
    <Route {...props} />
  ) : (
    <Redirect from={path} to={fallbackRedirectTo} />
  )
}

TrackedGremlinRoute.propTypes = {
  children: PropTypes.node,
  exact: PropTypes.bool,
  shouldRenderRoute: PropTypes.bool,
  name: PropTypes.string,
  component: PropTypes.any,
  render: PropTypes.func,
  computedMatch: PropTypes.object,
  location: PropTypes.object,
  loggedIn: PropTypes.bool,
  fallbackRedirectTo: PropTypes.string,
  path: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ])
}

TrackedGremlinRoute.defaultProps = {
  exact: false,
  shouldRenderRoute: true,
  loggedIn: false,
  tier: 'Unknown',
  fallbackRedirectTo: '/'
}
